module.exports = __webpack_public_path__ + "img/job-desc-ai-button.4ae5efd6.svg";